import React from "react";
import { useSelector } from "react-redux";
import {
  getElementById,
  getContainerClass,
  getLabelStyles,
} from "../utils/styleUtils";

export const CustomSelect = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Select element not found</div>;
  }

  const elementStyle = element.style || {};
  const labelPosition = elementStyle.labelPosition || "top";

  const handleSelectChange = (e) => {
    if (field && form) {
      form.setFieldValue(field.name, e.target.value);
    }
  };

  const getSelectStyles = () => {
    const baseStyles = {
      fontSize: elementStyle.fontSize || "0.875rem",
      padding: "0.5rem 0.75rem",
      borderRadius: elementStyle.borderRadius || "0.375rem",
      borderStyle: elementStyle.borderStyle || "solid",
      borderColor: elementStyle.borderColor || "#ced4da",
      backgroundColor: elementStyle.backgroundColor || "#FFFFFF",
      color: elementStyle.textColor || "#495057",
      appearance: "auto",
      width: "100%",
      height: elementStyle.height || "calc(1.5em + 0.75rem + 2px)",
      backgroundImage:
        "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 0.75rem center",
      backgroundSize: "16px 12px",
      transition:
        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    };

    if (labelPosition === "left" || labelPosition === "right") {
      return {
        ...baseStyles,
        flex: "1 1 auto",
        minWidth: "0",
      };
    }

    return baseStyles;
  };

  const options = elementStyle.options || ["Option 1", "Option 2", "Option 3"];

  return (
    <div className={getContainerClass(labelPosition)} style={{ width: "100%" }}>
      {elementStyle.label?.label && (
        <label
          htmlFor={`select-${instanceId}`}
          style={getLabelStyles(elementStyle, labelPosition)}
        >
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      <select
        id={`select-${instanceId}`}
        value={field?.value || ""}
        onChange={handleSelectChange}
        required={elementStyle.isRequired}
        style={getSelectStyles()}
        className="form-select"
        {...props}
      >
        <option value="">
          {elementStyle.placeholderText || "Select an option"}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>

      {elementStyle.helpText && (
        <small className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
          {elementStyle.helpText}
        </small>
      )}
    </div>
  );
};
